import { useDispatch } from "react-redux";
import { resetFilters, setFilter } from "..";

export const useDepositBatchesFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter = ({ key, value }: { key: string; value: unknown }) =>
    dispatch(setFilter({ key, value }));
  const reset = () => dispatch(resetFilters());
  return { updateFilter, reset };
};
